import { SENS_ACHAT, SENS_VENTE } from '@/configuration/devisConf';

export default function validation(response, sens) {
  const messages = [];
  let i18nType = '';
  switch (sens) {
    case SENS_ACHAT:
      i18nType = 'detailLotPaiement';
      break;
    case SENS_VENTE:
      i18nType = 'remiseBancaire';
      break;
    default:
      i18nType = '';
      break;
  }

  if (!response.data.error.validationErrors) {
    return messages;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('BANK_DELIVERY_WRITINGS_DELETE_ERROR') === 0) {
      messages.push({
        message: i18nType + '.msgError.errSuppEcritCompta',
      });
    }
    if (message.indexOf('BANK_DELIVERY_WITH_WRITING_IN_LOT') === 0) {
      messages.push({
        message: i18nType + '.msgError.errDevalidRemiseBanc',
      });
    }
  });
  return messages;
}
